import { createSlice } from "@reduxjs/toolkit";


const gptSlice = createSlice({
    name:'gpt',
    initialState: {
        showGptSearch: false,
        moviesResult: null,
        movieNames: null, 

    },
    reducers:{
        toggleGptSerchView: (state)=>{
            state.showGptSearch = !state.showGptSearch;   
        },
        addGptMovieResult: (state,action) =>{
            const {movieNames , moviesResult} = action.payload;
            state.movieNames = movieNames ;
            state.moviesResult = moviesResult;
        }
    },
});

export const  {toggleGptSerchView , addGptMovieResult} = gptSlice.actions

export default gptSlice.reducer